import React, { useEffect, useState } from "react";
import { IconButton } from "features/../../../shared/components/buttons";
import { connect } from "react-redux";
import { Button, Icon } from "semantic-ui-react";
import { Form, ModalBuilder } from "@redriver/cinnamon";
import Add from "features/../../../shared/assets/blue-add.svg";
import { getSheetDataState } from "features/Sheets";
import {
  getLFPItems,
  newLargeFormatScheduleGroup,
} from "features/Sheets/ManageSheet";
import { clearLargeFormatCreateModal } from "features/../../../shared/features/Settings/LargeFormat/actions";
import { calculateForm } from "features/Sheets/ManageSheet/actions";
import LargeFormatModalDetails from "./LargeFormatModalDetails";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { WarningBanner } from "features/../../../shared/components/banners";
import { maximumUtilityMetersForPrincipalMode } from "features/Sheets/ManageSheet/constants";

const ScheduleStepCreateLargeFormat = ({
  largeFormatGroups,
  sheetId,
  largeFormatCreateModal,
  largeFormatDefaults,
  clearLargeFormatCreateModal,
  sheetTypeView,
  calculateForm,
  disabled,
  sheet,
  showTooltip,
}) => {
  const { t } = useTranslation();

  const [exceedingUtilityLimit, setExceedingUtilityLimit] = useState(false);

  useEffect(() => {
    if (process.env.TRADE_AS_IPS) {
      setExceedingUtilityLimit(false);
      return;
    }

    const existingUtilityCount =
      (
        sheet.systemScheduleItems?.filter(
          (x) => x.unit.isUtility || x.addedAsUtility,
        ) || []
      ).length + getLFPItems(sheet.largeFormatGroups).length;

    const paperCount = (largeFormatCreateModal.lfRollMedia || []).length;
    const cleaningCount = largeFormatCreateModal.includeCleaning ? 1 : 0;
    const scanCount = largeFormatCreateModal.includeScan ? 1 : 0;
    const inkCount = 1;

    const modalUtilityCount = paperCount + cleaningCount + scanCount + inkCount;

    const totalUtilityCount = existingUtilityCount + modalUtilityCount;

    setExceedingUtilityLimit(
      totalUtilityCount > maximumUtilityMetersForPrincipalMode,
    );
  }, [sheet, largeFormatCreateModal, largeFormatGroups]);

  return (
    <ModalBuilder
      onCancelled={() => {
        clearLargeFormatCreateModal();
        calculateForm(false);
      }}
      onSubmit={() => calculateForm(false)}
      renderTrigger={(showModal) => (
        <div className="tooltip">
          <IconButton
            onClick={() => (clearLargeFormatCreateModal(), showModal())}
            className="wizard-title-button add-new-lfp"
            icon={Add}
            disabled={disabled}
            content={t("systemSchedule:buttons:addNewLargeFormat")}
          />
          {showTooltip && (
            <span className="tooltiptext">
              <div className="red-text bold">
                {t("systemSchedule:Maximum_Utility_Limit_Reached")}
              </div>
            </span>
          )}
        </div>
      )}
      renderModal={(modalProps) => (
        <TranslatedModal.Add
          {...modalProps}
          className="large-format-create-modal"
          header={t("systemSchedule:largeFormatModal:title")}
          submitDisabled={
            (exceedingUtilityLimit && !process.env.TRADE_AS_IPS) ||
            largeFormatCreateModal.printerId == null ||
            (largeFormatCreateModal.lfRollMedia || []).some(
              (pm) => !pm.paperWidthId || !pm.paperInclusiveId,
            )
          }
          submitLabel={
            <Form.ArrayAdder
              field="largeFormatGroups"
              arrayKey="id"
              as={Button}
              className="wizard-title-button positive large-format-save"
              content={
                <div className="large-format-save-btn">
                  {t("systemSchedule:largeFormatModal:saveBtn")}
                  <Icon name="checkmark" />
                </div>
              }
              populate={(k) => {
                const newItem = newLargeFormatScheduleGroup(
                  k,
                  largeFormatCreateModal,
                  largeFormatDefaults,
                  largeFormatGroups,
                  false,
                  sheet,
                );
                clearLargeFormatCreateModal();
                return newItem;
              }}
            />
          }
        >
          <LargeFormatModalDetails
            sheetId={sheetId}
            createVersion={true}
            sheetTypeView={sheetTypeView}
          />
          {exceedingUtilityLimit && !process.env.TRADE_AS_IPS && (
            <WarningBanner
              warningText={t("systemSchedule:Maximum_Utility_Limit_Reached")}
            />
          )}
        </TranslatedModal.Add>
      )}
    />
  );
};

const mapStateToProps = (state) => {
  const sheet = getSheetDataState(state);

  const { largeFormatCreateModal } = getSheetDataState(state),
    { defaults, largeFormatGroups } = getSheetDataState(state);

  return {
    sheet,
    largeFormatGroups,
    largeFormatCreateModal,
    largeFormatDefaults: defaults.largeFormatDefaults,
  };
};

const actions = {
  clearLargeFormatCreateModal,
  calculateForm,
};

export default connect(mapStateToProps, actions)(ScheduleStepCreateLargeFormat);
